import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useImportanceByRubricStatBlocksStore = createAnalyticsStore(
  "importanceByRubricStatBlocksStore",
  "Analytics/rubrics/importance/by_day_of_week/:projectId",
  { loadStatType: "withBody" }
);